module.exports = __webpack_public_path__ + "static/media/Printery_Machine.e9fb05c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/Printery_Machine.png
// module id = 1570
// module chunks = 0